const logo = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/logo.png';
const btn_login = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_login.png';
const btn_logout = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_logout.png';
const btn_detail = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_detail.png';
const join_blue = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/join_blue.png';
const join_red = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/join_red.png';
const join_yellow = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/join_yellow.png';
const join_green = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/join_green.png';
const btn_join_blue = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_join_blue.png';
const btn_join_red = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_join_red.png';
const btn_join_yellow = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_join_yellow.png';
const btn_join_green = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_join_green.png';
const icon_blue = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/icon_blue.png';
const icon_red = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/icon_red.png';
const icon_yellow = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/icon_yellow.png';
const icon_green = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/icon_green.png';
const icon_blue_active = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/icon_blue_active.png';
const icon_red_active = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/icon_red_active.png';
const icon_yellow_active = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/icon_yellow_active.png';
const icon_green_active = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/icon_green_active.png';
const btn_reward = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_reward.png';
const btn_ok = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_ok.png';
const logo_blue = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/logo_blue.png';
const logo_red = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/logo_red.png';
const logo_yellow = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/logo_yellow.png';
const logo_green = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/logo_green.png';
const king_blue = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/king_blue.png';
const king_red = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/king_red.png';
const king_yellow = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/king_yellow.png';
const king_green = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/king_green.png';
const btn_close = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_close.png';
const giftbox = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/giftbox.png';
const crown = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/crown.png';
const cup = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/cup.png';
const medal_1 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/medal_1.png';
const medal_2 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/medal_2.png';
const medal_3 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/medal_3.png';
const success_blue = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/success_blue.png';
const success_red = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/success_red.png';
const success_yellow = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/success_yellow.png';
const success_green = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/success_green.png';
const btn_ok_blue = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_ok_blue.png';
const btn_ok_red = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_ok_red.png';
const btn_ok_yellow = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_ok_yellow.png';
const btn_ok_green = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_ok_green.png';
const btn_cancel_blue = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_cancel_blue.png';
const btn_cancel_red = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_cancel_red.png';
const btn_cancel_yellow = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_cancel_yellow.png';
const btn_cancel_green = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/btn_cancel_green.png';
const reward_row_1 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_1.png';
const reward_row_2_1 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_2_1.png';
const reward_row_2_2 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_2_2.png';
const reward_row_3_1 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_3_1.png';
const reward_row_3_2 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_3_2.png';
const reward_row_4_1 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_4_1.png';
const reward_row_4_2 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_4_2.png';
const reward_row_5_1 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_5_1.png';
const reward_row_5_2 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_5_2.png';
const reward_row_6_1 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_6_1.png';
const reward_row_6_2 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_6_2.png';
const reward_row_7_1 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_7_1.png';
const reward_row_7_2 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/reward_row_7_2.png';
const bg_main = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/bg_main.jpg';
const bg_red = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/bg_red.jpg';
const bg_blue = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/bg_blue.jpg';
const bg_green = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/bg_green.jpg';
const bg_yellow = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/bg_yellow.jpg';
const logo_2 = 'https://cdn-webth.garenanow.com/webth/cdn/fconline/fclympic/logo_2.png';

export const Imglist = {
    logo,
    btn_login,
    btn_logout,
    btn_detail,
    join_blue,
    join_red,
    join_yellow,
    join_green,
    btn_join_blue,
    btn_join_red,
    btn_join_yellow,
    btn_join_green,
    icon_blue,
    icon_red,
    icon_yellow,
    icon_green,
    icon_blue_active,
    icon_red_active,
    icon_yellow_active,
    icon_green_active,
    btn_reward,
    btn_ok,
    logo_blue,
    logo_red,
    logo_yellow,
    logo_green,
    king_blue,
    king_red,
    king_yellow,
    king_green,
    btn_close,
    giftbox,
    crown,
    cup,
    medal_1,
    medal_2,
    medal_3,
    success_blue,
    success_red,
    success_yellow,
    success_green,
    btn_ok_blue,
    btn_ok_red,
    btn_ok_yellow,
    btn_ok_green,
    btn_cancel_blue,
    btn_cancel_red,
    btn_cancel_yellow,
    btn_cancel_green,
    reward_row_1,
    reward_row_2_1,
    reward_row_2_2,
    reward_row_3_1,
    reward_row_3_2,
    reward_row_4_1,
    reward_row_4_2,
    reward_row_5_1,
    reward_row_5_2,
    reward_row_6_1,
    reward_row_6_2,
    reward_row_7_1,
    reward_row_7_2,
    bg_main,
    bg_red,
    bg_blue,
    bg_green,
    bg_yellow,
    logo_2,
}
